import {defineArrayMember} from 'sanity'
import H2Question from './H2Question'

export default defineArrayMember({
  type: 'block',
  options: {
    spellCheck: true,
  },
  marks: {
    annotations: [
      defineArrayMember({
        title: 'URL',
        name: 'link',
        type: 'object',
        fields: [
          {
            title: 'URL',
            name: 'href',
            type: 'url',
            validation: (Rule) =>
              Rule.uri({
                allowRelative: true,
                scheme: ['http', 'https', 'mailto'],
              }),
          },
          {
            title: 'Open in new tab',
            name: 'openInNewTab',
            type: 'boolean',
          },
        ],
      }),
    ],
    decorators: [
      {title: 'Strong', value: 'strong'},
      {title: 'Emphasis', value: 'em'},
      {title: 'Code', value: 'code'},
      {title: 'Underline', value: 'underline'},
      {title: 'Strike', value: 'strike-through'},
    ],
  },
  styles: [
    {title: 'Normal', value: 'normal'},
    {title: 'H1', value: 'h1'},
    {title: 'H2', value: 'h2'},
    {
      title: 'H2 - Question',
      value: 'h2-question',
      component: ({children}) => <H2Question>{children}</H2Question>,
    },
    {title: 'H3', value: 'h3'},
  ],
})
